import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { companyInfo } from '../mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-100 rounded-full blur-3xl opacity-30"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-stone-100 rounded-full blur-3xl opacity-30"></div>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-amber-100 text-amber-900 px-4 py-2 rounded-full text-sm font-semibold">
                {companyInfo.serviceArea}
              </span>
            </div>
            
            <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 leading-tight">
              {companyInfo.name}
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {companyInfo.tagline}
            </p>

            <div className="space-y-3">
              {[
                'Comprehensive Property Services',
                'Expert Real Estate Solutions',
                'Trusted by Homeowners & Investors'
              ].map((item, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckCircle className="w-5 h-5 text-amber-800 flex-shrink-0" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                onClick={() => scrollToSection('contact')}
                size="lg"
                className="bg-amber-800 hover:bg-amber-900 text-white text-lg px-8 py-6 transition-all transform hover:scale-105"
              >
                Get Free Consultation
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button 
                onClick={() => scrollToSection('property-services')}
                size="lg"
                variant="outline"
                className="border-2 border-gray-300 hover:border-amber-800 hover:text-amber-800 text-lg px-8 py-6 transition-all"
              >
                View Our Services
              </Button>
            </div>
          </div>

          {/* Right Content - Image with Stats Overlay */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.pexels.com/photos/17474981/pexels-photo-17474981.jpeg?w=800&q=80" 
                alt="Cape Cod Property Services"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Stats Overlay */}
            <div className="absolute -bottom-6 -left-6 right-6 grid grid-cols-2 gap-4">
              {[
                { number: '15+', label: 'Years Experience' },
                { number: '500+', label: 'Happy Clients' }
              ].map((stat, index) => (
                <div 
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 backdrop-blur-sm"
                >
                  <div className="text-3xl font-bold text-amber-800 mb-1">{stat.number}</div>
                  <div className="text-gray-600 text-sm font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
